import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
import createTransition from 'shared-tokens/utils/createTransition';

import { mainCls as cardCls } from '../../style';

const brSmartphone = createBreakpoint('xs');
const brTablet = createBreakpoint('s');

export const mainCls =  `${cardCls}__units`;

export default {
  [`${mainCls}__tit`]: {
    lineHeight: '20px',
  },
  [`${mainCls}__container`]: {
    maxHeight: 132,
    transition: createTransition(['max-height']),
    overflow: 'hidden',
  },
  [`${mainCls}__container__map`]: {
    maxHeight: 194,
  },
  [`${mainCls}__grid`]: {
    paddingTop: 4,
    paddingBottom: 4,
    lineHeight: '18px',
    [brSmartphone]: {
      paddingTop: 12,
      paddingBottom: 12,
      lineHeight: '20px',
    },
    [brTablet]: {
      '&:hover': {
        opacity: .6,
        '& .csaSrpcard__units__arrow': {
          transform: 'translate(4px, -50%) rotateZ(270deg)',
        }
      },
      '&:active': {
        opacity: 1,
      },
    },
    '& span': {
      pointerEvents: 'none',
    },
  },
  
  [`${mainCls}__mapfeat`]: {
    minWidth: 'calc(33% - 8px)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  [`${mainCls}__type`]: {
    [brSmartphone]: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  [`${mainCls}__onlydsk`]: {
    display: 'none',
    [brTablet]: {
      display: 'block',
    },
  },
  [`${mainCls}__notonmap`]: {
    display: 'none',
  },
  [`${mainCls}__price`]: {
    whiteSpace: 'nowrap',
    [brSmartphone]: {
      textAlign: 'center',
    },
  },
  [`${mainCls}__arrowCont`]: {
    width: 24,
    height: 20,
  },
  [`${mainCls}__arrow`]: {
    position: 'absolute',
    top: '50%',
    left: 8,
    transform: 'translate(0, -50%) rotateZ(270deg)',
    transition: createTransition(['transform']),
  },
  [`${mainCls}__reveal`]: {
    padding: 0,
    width: '100%',
    lineHeight: '48px',   
    [brTablet]: {
      transition: createTransition(['color']),
      '&:hover': {
        color: `${colors.secondary.rgba} !important`,
        '& .csaSrpcard__units__reveal__icon': {
          transform: 'translate(0, 2px)',
        },
        '& .csaSrpcard__units__reveal__icon.inverted': {
          transform: 'translate(0, -2px) rotateZ(180deg)',
        }
      },
    },
  },
  [`${mainCls}__reveal--cont`]: {
    display: 'inline-block',
    paddingRight: 18,
  },
  [`${mainCls}__reveal__icon`]: {
    position: 'absolute',
    top: 17,
    right: 0,
    transition: createTransition(['transform']),
    '&.inverted': {
      transform: 'rotateZ(180deg)',
    }
  },
};
